import React from 'react'
import styled from 'styled-components'
import { Logo } from 'sutra/components/Logo/Logo'
import { accents, brand } from 'sutra/tokens/colors'

// Single source of truth for the auth card's width — consumed by AuthLayout
// so the card and the "Sign up" line beneath it can't drift apart.
export const AUTH_CARD_WIDTH = 400

interface AuthCardProps {
  children: React.ReactNode
}

export const AuthCard: React.FC<AuthCardProps> = ({ children }) => {
  return (
    <Card>
      <Logo $tone="primary" $height={32} />
      {children}
    </Card>
  )
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: ${AUTH_CARD_WIDTH}px;
  box-sizing: border-box;
  padding: 28px 24px 24px;
  background: ${brand.white};

  .ant-form-item-label > label {
    font-family: 'Poppins', system-ui, sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #414651;
  }

  .ant-form-item-has-error .ant-form-item-label > label {
    color: ${accents.crimsonBloom[500]};
  }
`
